/* unplugin-vue-components disabled */import { render } from "./md-content.vue?vue&type=template&id=b42f8088"
import script from "./md-content.vue?vue&type=script&lang=js"
export * from "./md-content.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/md-content-v2/md-content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b42f8088"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b42f8088', __exports__)) {
    api.reload('b42f8088', __exports__)
  }
  
  module.hot.accept("./md-content.vue?vue&type=template&id=b42f8088", () => {
    api.rerender('b42f8088', render)
  })

}


export default __exports__